  import React, { useState } from "react";
  import { Link } from "react-router-dom";
  import { MoveLeft, Plus } from "lucide-react";


  const DynamicForm = ({
    fields,
    page_title,
    btn_name1,
    btn_name1_route,
    formik,
    btn_name,
    TokenData,
    mcxSymbols = [],  
    rowData,
    title,
    additional_field,
    btn_status,
    content_btn_name,
    content_path,
    btn_name2,
  }) => {
    const [previews, setPreviews] = useState([]);
    const [passwordVisible, setPasswordVisible] = useState({});
    const [inputValue, setInputValue] = useState("");
    const [selectedImage, setSelectedImage] = useState(null);

    const handleFileChange = (event, index, name) => {
      if (event.target.files[0].size > 420000) {
        alert("Select file less then 420KB");
        event.target.value = "";
        return;
      } else {
        const file = event.target.files[0];
        const newPreviews = [...previews];
        newPreviews[index] = URL.createObjectURL(file);
        setPreviews(newPreviews);
        setSelectedImage(file);
        const reader = new FileReader();
        reader.onload = () => {
          formik.setFieldValue(name, reader.result);
        };
        reader.readAsDataURL(file);
      }
    };

    return (
      <div
        className="content container-fluid mt-5 "
        data-aos="fade-left"

      >
        <div className="row justify-content-center  " >
          <div className="col-xl-12 col-lg-12">
            <div
              className="card shadow-lg  rounded-3 py-2 "

            >

              {/* HEADER */}
              {(page_title || btn_status === "true") && (
                <div className="card-header d-flex justify-content-between align-items-center bg-white border-0">
                  <div className="d-flex align-items-center">
                    {page_title && (
                      <>
                        <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary text-white me-2"
                          style={{ width: 36, height: 36 }}>
                          <i className="fa-regular fa-circle-user" />
                        </div>
                        <div>
                          <h4 className="mb-0 fw-semibold">{page_title}</h4>
                          <small className="text-muted">
                            Fill the fields below and click save.
                          </small>
                        </div>
                      </>
                    )}
                  </div>

                  {btn_status === "true" && (
                    <div className="d-flex align-items-center gap-2">
                      {content_btn_name === "Back" ? (
                        <Link
                          to={content_path}
                          className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
                        >
                          <MoveLeft size={16} />
                          {content_btn_name}
                        </Link>
                      ) : (
                        <Link
                          to={content_path}
                          className="btn btn-primary btn-sm d-flex align-items-center gap-1"
                        >
                          <Plus size={16} />
                          {content_btn_name}
                        </Link>
                      )}
                    </div>
                  )}
                </div>
              )}

              {/* FORM */}
              <form onSubmit={formik.handleSubmit} autoComplete="off">
                <div className="card-body" style={{ padding: "25px 28px", }}>
                  <div
                    className="row py-3 rounded-3"
                    style={{

                      border: "1px solid #e1e5ea",
                      backgroundColor: "#ffffff",

                    }}
                  >
                    {fields.map((field, index) => {
                      if (field.type === "custom" && field.name === "market_ui") {
    return (
      <div className="col-lg-12" key={field.name}>

        {/* Trade Block */}
        <div className="mb-3">
          <label className="fw-bold">Trade Block Duration</label>
          <input
            type="text"
            className="form-control"
            placeholder="mm:ss"
            value={formik.values.trade_block_time || ""}
            onChange={(e) => {
              let value = e.target.value;
              if (/^[0-9]{0,2}(:[0-9]{0,2})?$/.test(value)) {
                formik.setFieldValue("trade_block_time", value);
              }
            }}
          />
        </div>

        {/* Market */}
        <label className="fw-bold mb-2">Select Markets</label>
        <div className="d-flex gap-4">

          {/* Forex */}
          {TokenData?.market?.includes(0) && (
            <div className="form-check gap-4">
              <input
                type="checkbox"
                className="me-2 form-check-input" 
                checked={formik.values.market.includes(0)}
                  disabled={rowData?.market?.includes(0)}
                onChange={(e) => {
                  if (e.target.checked) {
                    formik.setFieldValue("market", [...formik.values.market, 0]);
                  } else {
                    formik.setFieldValue("market", formik.values.market.filter((m) => m !== 0));
                  }
                }}
              />
              <label>Forex</label>
            </div>
          )}

          {/* India */}
          {TokenData?.market.includes(1) && (
            <div className="form-check">
              <input
                type="checkbox"
                className="me-2 form-check-input" 
                checked={formik.values.market.includes(1)}
                    disabled={rowData?.market?.includes(1)}
                onChange={(e) => {
                  if (e.target.checked) {
                    formik.setFieldValue("market", [...formik.values.market, 1]);
                  } else {
                    formik.setFieldValue("market", formik.values.market.filter((m) => m !== 1));
                  }
                }}
              />
              <label>India</label>
            </div>
          )}
        </div>

        {/* Error */}
        {formik.errors.market && (
          <div className="text-danger mt-2 small">{formik.errors.market}</div>
        )}

        {/* MCX Button */}
        {formik.values.market.includes(1) && (
          <button
            type="button"
            className="btn btn-primary mt-3"
            onClick={() =>
              formik.setFieldValue("mcxEnabled", !formik.values.mcxEnabled)
            }
          >
            Add MCX Symbols
          </button>
        )}

        {/* MCX Inputs */}
        {formik.values.market.includes(1) && formik.values.mcxEnabled && (
          <div className="row mt-4">
            {(mcxSymbols || []).map((symbol) => (
              <div key={symbol} className="col-md-4 mb-3">
                <label>{symbol}</label>
                <input
                  type="number"
                  className="form-control"
                  value={formik.values.mcxData?.[symbol] || ""}
                  onChange={(e) => {
                    formik.setFieldValue("mcxData", {
                      ...formik.values.mcxData,
                      [symbol]: e.target.value,
                    });
                  }}
                />
              </div>
            ))}
          </div>
        )}

      </div>
    );
  }

  return (
                      <React.Fragment key={index}>
                        {field.type === "heading" && (
                          <div
                            style={{
                              background: "#F9FAFF",
                              margin: "12px 0",
                              padding: "15px 20px",
                              boxShadow: "0 2px 6px rgba(73, 73, 73, 0.08)"
                            }}
                            className="col-12"
                          >
                            <h5
                              style={{
                                margin: 0,
                                paddingLeft: "10px",

                                fontWeight: "600",
                                fontSize: "18px",
                              }}
                            >
                              {field.label}
                            </h5>
                          </div>
                        )}
                        {field.name === "username" && field.type === "text" ? (
                          <div className={`col-12 col-lg-${field.col_size}`}>
                            <div className=" d-flex flex-column">
                              <label className="form-label mb-1">
                                {field.label}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                autoComplete="off"
                                className="form-control   shadow-sm "
                                placeholder={`Enter ${field.label}`}
                                readOnly={field.disable}
                                id={field.name}
                                name={field.name}
                                value={formik.values[field.name]}
                                style={{
                                  boxShadow: "none",
                                  outline: "none",
                                  borderColor: "#ddd",


                                }}

                                onChange={(e) => {
                                  const value = e.target.value
                                    .toLowerCase()
                                    .replace(/[^a-z0-9]/g, "");
                                  formik.setFieldValue(field.name, value);
                                }}
                              />
                              {formik.touched[field.name] &&
                                formik.errors[field.name] && (
                                  <div className="text-danger small mt-1">
                                    {formik.errors[field.name]}
                                  </div>
                                )}
                            </div>
                          </div>
                        ) : field.type === "text" ? (
                          <div className={`col-12 col-lg-${field.col_size}`}>
                            <div className="mb-1 d-flex flex-column">
                              <label className="form-label mb-1">
                                {field.label}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                autoComplete="off"
                                className="form-control  shadow-sm "
                                placeholder={`Enter ${field.label}`}
                                readOnly={field.disable}
                                id={field.name}
                                name={field.name}
                                value={formik.values[field.name]}

                                onChange={(e) => {
                                  const lowercaseValue =
                                    e.target.value.toLowerCase();
                                  formik.setFieldValue(field.name, lowercaseValue);
                                }}
                              />
                              {formik.touched[field.name] &&
                                formik.errors[field.name] && (
                                  <div className="text-danger small mt-1">
                                    {formik.errors[field.name]}
                                  </div>
                                )}
                            </div>
                          </div>
                        ) : field.type === "percentage" ? (
                          <div className={`col-12 col-lg-${field.col_size}`}>
                            <div className="mb-3 d-flex flex-column">
                              <label className="form-label mb-1">
                                {field.label}
                              </label>
                              <input
                                type="text"
                                min={1}
                                max={10000}
                                autoComplete="off"
                                className="form-control  shadow-sm "
                                placeholder={`Enter ${field.label}`}
                                readOnly={field.disable}
                                id={field.name}
                                name={field.name}
                                {...formik.getFieldProps(field.name)}
                                onInput={(e) => {
                                  const val = e.target.value;
                                  Math.max(0, Math.min(10000, e.target.value));
                                  e.target.value = val;
                                  formik.setFieldValue(field.name, e.target.value);
                                }}
                              />
                              {formik.touched[field.name] &&
                                formik.errors[field.name] && (
                                  <div className="text-danger small mt-1">
                                    {formik.errors[field.name]}
                                  </div>
                                )}
                            </div>
                          </div>
                        ) : field.type === "text2" ? (
                          <div className={`col-12 col-lg-${field.col_size}`}>
                            <div className="mb-3 d-flex flex-column">
                              <label className="form-label mb-1">
                                {field.label}
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                autoComplete="off"
                                className="form-control  shadow-sm "
                                placeholder={`Enter ${field.label}`}
                                readOnly={field.disable}
                                id={field.name}
                                name={field.name}
                                value={inputValue}
                                onChange={(e) => {
                                  const newValue = e.target.value.toUpperCase();
                                  if (/^[a-zA-Z]{0,3}$/.test(newValue)) {
                                    setInputValue(newValue);
                                    formik.handleChange(e);
                                  }
                                }}
                              />
                              {inputValue === "" && formik.errors[field.name] && (
                                <div className="text-danger small mt-1">
                                  {formik.errors[field.name]}
                                </div>
                              )}
                            </div>
                          </div>
                        ) : field.type === "file" ? (
                          <div className={`col-12 col-lg-${field.col_size}`}>
                            <div className="mb-3 d-flex flex-column">
                              <div className="d-flex align-items-center mb-2">
                                <div
                                  className="rounded-circle overflow-hidden border me-3"
                                  style={{
                                    width: 64,
                                    height: 64,
                                    background: "#f1f5f9",
                                  }}
                                >
                                  <img
                                    id="blah"
                                    className="w-100 h-100"
                                    style={{ objectFit: "cover" }}
                                    src={
                                      formik.values[field.name]
                                        ? formik.values[field.name]
                                        : "assets/img/profiles/avatar-14.jpg"
                                    }
                                    alt="profile-img"
                                  />
                                </div>
                                <div>
                                  <div className="fw-semibold small">
                                    Upload a Photo
                                  </div>
                                  <div className="text-muted small">
                                    {selectedImage
                                      ? selectedImage.name
                                      : "Profile-pic.jpg"}
                                  </div>
                                </div>
                              </div>
                              <label className="btn btn-outline-secondary btn-sm w-auto">
                                Upload
                                <input
                                  type="file"
                                  id={field.name}
                                  className="d-none"
                                  onChange={(e) =>
                                    handleFileChange(e, index, field.name)
                                  }
                                />
                              </label>
                            </div>
                          </div>
                        ) : field.type === "file1" ? (
                          <div className={`col-12 col-lg-${field.col_size}`}>
                            <div className="mb-3 d-flex flex-column">
                              <label
                                className="form-label mb-1"
                                htmlFor={field.name}
                              >
                                {field.label}
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="file"
                                id={field.name}
                                onChange={(e) =>
                                  handleFileChange(e, index, field.name)
                                }
                                className="form-control  shadow-sm "
                              />
                              {formik.getFieldProps(field.name).value && (
                                <img
                                  src={formik.getFieldProps(field.name).value}
                                  alt={`Preview ${index}`}
                                  className="mt-2 border rounded"
                                  style={{
                                    height: 150,
                                    width: "100%",
                                    objectFit: "contain",
                                  }}
                                />
                              )}
                            </div>
                          </div>
                        ) : field.type === "select" ? (
                          <div
                            className={`col-12 col-lg-${title === "update_theme" ? 12 : 6
                              }`}
                          >
                            <div className="mb-3 d-flex flex-column">
                              <label
                                className="form-label mb-1"
                                htmlFor={field.name}
                              >
                                {field.label}
                              </label>
                              <select
                                className="form-select shadow-sm "
                                disabled={field.disable}
                                id={field.name}
                                name={field.name}
                                value={formik.values[field.name]}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              >
                                <option value="">Select {field.label}</option>
                                {field.options.map((option) => (
                                  <option
                                    key={option.value}
                                    value={option.value}
                                  >
                                    {option.label}
                                  </option>
                                ))}
                              </select>
                              {formik.touched[field.name] &&
                                formik.errors[field.name] && (
                                  <div className="text-danger small mt-1">
                                    {formik.errors[field.name]}
                                  </div>
                                )}
                            </div>
                          </div>
                        ) : field.type === "select1" ? (
                          <div
                            className={`col-12 col-lg-${title === "update_theme" ? 12 : 6
                              }`}
                          >
                            <div className="mb-3 d-flex flex-column">
                              <label
                                className="form-label mb-1"
                                htmlFor={field.name}
                              >
                                {field.label}
                              </label>
                              <select
                                className="form-select shadow-sm "
                                disabled={field.disable}
                                id={field.name}
                                value={formik.values[field.name]}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                name={field.name}
                              >
                                <option value="">Select {field.label}</option>
                                {field.options.map((option) => (
                                  <option
                                    key={option.value}
                                    value={option.value}
                                  >
                                    {option.label}
                                  </option>
                                ))}
                              </select>
                              {formik.touched[field.name] &&
                                formik.errors[field.name] && (
                                  <div className="text-danger small mt-1">
                                    {formik.errors[field.name]}
                                  </div>
                                )}
                            </div>
                          </div>
                        ) : field.type === "toggle" ? (
                          <div className={`col-12 col-lg-${field.col_size}`}>
                            <label className="form-label mt-2 mb-1">
                              {field.label}
                            </label>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id={field.name}
                                checked={formik.values[field.name]}
                                disabled={field.disable}
                                onChange={(e) => {
                                  const val = e.target.checked;
                                  formik.setFieldValue(field.name, val);
                                  if (field.onChange) field.onChange(val);
                                }}
                              />
                              <label
                                className="form-check-label ms-2 small"
                                htmlFor={field.name}
                              >
                                {formik.values[field.name]
                                  ? "Enabled"
                                  : "Disabled"}
                              </label>
                            </div>
                            {formik.errors[field.name] && (
                              <div className="text-danger small mt-1">
                                {formik.errors[field.name]}
                              </div>
                            )}
                          </div>
                        ) : field.type === "checkbox" ? (
                          <div className={`col-12 col-lg-${field.col_size}`}>
                            <div className="form-check mt-3">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                disabled={field.disable}
                                id={field.name}
                                checked={!!formik.values[field.name]}
                                onChange={(e) => {
                                  const val = e.target.checked;
                                  formik.setFieldValue(field.name, val);
                                  if (field.onChange) field.onChange(val);
                                }}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={field.name}
                              >
                                {field.label}
                              </label>
                            </div>
                            {formik.errors[field.name] && (
                              <div className="text-danger small mt-1">
                                {formik.errors[field.name]}
                              </div>
                            )}
                          </div>
                        ) : field.type === "radio" ? (
                          <>
                            <div className="col-12">
                              <label className="mb-1 text-decoration-underline">
                                {field.parent_label}
                              </label>
                            </div>
                            <div className="col-12 d-flex flex-wrap">
                              <div className="form-check me-3">
                                <input
                                  type="radio"
                                  name={field.name}
                                  value={field.value1}
                                  className="form-check-input"
                                  id={field.title1}
                                  {...formik.getFieldProps(field.name)}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={field.title1}
                                >
                                  {field.title1}
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name={field.name}
                                  value={field.value2}
                                  className="form-check-input"
                                  id={field.title2}
                                  {...formik.getFieldProps(field.name)}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={field.title2}
                                >
                                  {field.title2}
                                </label>
                              </div>
                            </div>
                          </>
                        ) : field.type === "password" ? (
                          <div className={`col-12 col-lg-${field.col_size}`}>
                            <div className="mb-3 d-flex flex-column">
                              <label
                                className="form-label mb-1"
                                htmlFor={field.name}
                              >
                                {field.label}
                                <span className="text-danger">*</span>
                              </label>
                              <div style={{ position: "relative" }}>
                                <input
                                  id={field.name}
                                  autoComplete="new-password"
                                  type={
                                    passwordVisible[field.name]
                                      ? "text"
                                      : field.type
                                  }
                                  placeholder={`Enter ${field.label}`}
                                  {...formik.getFieldProps(field.name)}
                                  className="form-control  shadow-sm "
                                />
                                <i
                                  className={`fa-solid ${passwordVisible[field.name]
                                    ? "fa-eye-slash"
                                    : "fa-eye"
                                    }`}
                                  style={{
                                    position: "absolute",
                                    top: "50%",
                                    right: 10,
                                    transform: "translateY(-50%)",
                                    cursor: "pointer",
                                    color: "#6c757d",
                                  }}
                                  onClick={() =>
                                    setPasswordVisible((prevState) => ({
                                      ...prevState,
                                      [field.name]: !prevState[field.name],
                                    }))
                                  }
                                ></i>
                              </div>
                              {formik.touched[field.name] &&
                                formik.errors[field.name] && (
                                  <div className="text-danger small mt-1">
                                    {formik.errors[field.name]}
                                  </div>
                                )}
                            </div>
                          </div>
                        ) : field.type === "password1" ? (
                          <div className={`col-12 col-lg-${field.col_size}`}>
                            <div className="mb-3 d-flex flex-column">
                              <label
                                className="form-label mb-1"
                                htmlFor={field.name}
                              >
                                {field.label}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                id={field.name}
                                autoComplete="new-password1"
                                type={
                                  passwordVisible[field.name]
                                    ? "text"
                                    : field.type
                                }
                                placeholder={`Enter ${field.label}`}
                                {...formik.getFieldProps(field.name)}
                                className="form-control  shadow-sm "
                              />
                              {formik.touched[field.name] &&
                                formik.errors[field.name] && (
                                  <div className="text-danger small mt-1">
                                    {formik.errors[field.name]}
                                  </div>
                                )}
                            </div>
                          </div>
                        ) : field.type === "date" ? (
                          <div className={`col-12 col-lg-${field.col_size}`}>
                            <div className="mb-3 d-flex flex-column">
                              <label
                                className="form-label mb-1"
                                htmlFor={field.name}
                              >
                                {field.name}
                              </label>
                              <input
                                type="date"
                                name={field.name}
                                className="form-control  shadow-sm "
                                id={field.name}
                                {...formik.getFieldProps(field.name)}
                              />
                              {formik.errors[field.name] && (
                                <div className="text-danger small mt-1">
                                  {formik.errors[field.name]}
                                </div>
                              )}
                            </div>
                          </div>
                        ) : field.type === "msgbox" ? (
                          <div className={`col-12 col-lg-${field.col_size}`}>
                            <div className="mb-3 d-flex flex-column">
                              <label
                                className="form-label mb-1"
                                htmlFor={field.name}
                              >
                                {field.label}
                              </label>
                              <textarea
                                className="form-control  shadow-sm "
                                rows={field.row_size}
                                id={field.name}
                                name={field.name}
                                {...formik.getFieldProps(field.name)}
                                placeholder={field.label}
                              />
                              {formik.errors[field.name] && (
                                <div className="text-danger small mt-1">
                                  {formik.errors[field.name]}
                                </div>
                              )}
                            </div>
                          </div>
                        ) : field.type === "test" ? (
                          <div className={`col-12 col-lg-${field.col_size}`}>
                            <div className="mb-3" />
                          </div>
                        ) : field.type === "number" ? (
                          <div className={`col-12 col-lg-${field.col_size}`}>
                            <div className="mb-3 d-flex flex-column">
                              <label
                                className="form-label mb-1"
                                htmlFor={field.name}
                              >
                                {field.label}
                              </label>
                              <input
                                type="number"
                                name={field.name}
                                className="form-control  shadow-sm "
                                id={field.name}
                                placeholder={`Enter ${field.label}`}
                                {...formik.getFieldProps(field.name)}
                              />
                              {formik.touched[field.name] &&
                                formik.errors[field.name] && (
                                  <div className="text-danger small mt-1">
                                    {formik.errors[field.name]}
                                  </div>
                                )}
                            </div>
                          </div>
                        ) : field.type === "text3" ? (
                          <div className={`col-12 col-lg-${field.col_size}`}>
                            <div className="mb-3 d-flex flex-column">
                              <label
                                className="form-label mb-1"
                                htmlFor={field.name}
                              >
                                {field.label}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                name={field.name}
                                readOnly={field.disable}
                                className="form-control  shadow-sm "
                                id={field.name}
                                placeholder={`Enter ${field.label}`}
                                {...formik.getFieldProps(field.name)}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  const newValue = value
                                    .replace(/\D/g, "")
                                    .slice(0, 10);
                                  e.target.value = newValue;
                                  formik.handleChange(e);
                                }}
                              />
                              {formik.touched[field.name] &&
                                formik.errors[field.name] && (
                                  <div className="text-danger small mt-1">
                                    {formik.errors[field.name]}
                                  </div>
                                )}
                            </div>
                          </div>
                        ) : field.type === "text4" ? (
                          <div className={`col-12 col-lg-${field.col_size}`}>
                            <div className="mb-3 d-flex flex-column">
                              <label
                                className="form-label mb-1"
                                htmlFor={field.name}
                              >
                                {field.label}
                              </label>
                              <input
                                type="number"
                                name={field.name}
                                readOnly={field.disable}
                                className="form-control  shadow-sm "
                                id={field.name}
                                placeholder={`Enter ${field.label}`}
                                value={formik.values[field.name]}
                                min={0}
                                max={100}
                                onChange={(e) => {
                                  let value = e.target.value;
                                  let numericValue = parseInt(value, 10);
                                  if (isNaN(numericValue)) {
                                    numericValue = "";
                                  } else if (numericValue > 100) {
                                    numericValue = 100;
                                  } else if (numericValue < 0) {
                                    numericValue = 0;
                                  }
                                  formik.setFieldValue(field.name, numericValue);
                                }}
                              />
                              {formik.touched[field.name] &&
                                formik.errors[field.name] && (
                                  <div className="text-danger small mt-1">
                                    {formik.errors[field.name]}
                                  </div>
                                )}
                            </div>
                          </div>
                        ) : field.type === "text5" ? (
                          <div className={`col-12 col-lg-${field.col_size}`}>
                            <div className="mb-3 d-flex flex-column">
                              <label
                                className="form-label mb-1"
                                htmlFor={field.name}
                              >
                                {field.label}
                              </label>
                              <input
                                type="number"
                                name={field.name}
                                readOnly={field.disable}
                                className="form-control  shadow-sm "
                                id={field.name}
                                placeholder={`Enter ${field.label}`}
                                {...formik.getFieldProps(field.name)}
                                min={1}
                                onChange={(e) => {
                                  let value = e.target.value;
                                  value = value.replace(/^0+/, "");
                                  if (value === "") {
                                    value = "";
                                  }
                                  value = Math.min(
                                    parseInt(value),
                                    10000000000
                                  );
                                  e.target.value = value;
                                  formik.handleChange(e);
                                }}
                              />
                              {formik.touched[field.name] &&
                                formik.errors[field.name] && (
                                  <div className="text-danger small mt-1">
                                    {formik.errors[field.name]}
                                  </div>
                                )}
                            </div>
                          </div>
                        ) : field.type === "security" ? (
                          <div className={`col-12 col-lg-${field.col_size}`}>
                            <label className="form-label">{field.label}</label>
                          </div>
                        ) : field.type === "convertprice" ? (
                          <div
                            className={`col-12 col-md-${field.col_size}`}
                          >
                            <label
                              htmlFor={field.name}
                              className="form-label mb-1"
                            >
                              {field.label}
                            </label>
                            <input
                              type="text"
                              id={field.name}
                              {...formik.getFieldProps(field.name)}
                              disabled={field.disable}
                              className={`form-control  shadow-sm  ${formik.touched[field.name] &&
                                formik.errors[field.name]
                                ? "is-invalid"
                                : ""
                                }`}
                            />
                            {formik.touched[field.name] &&
                              formik.errors[field.name] && (
                                <div className="invalid-feedback">
                                  {formik.errors[field.name]}
                                </div>
                              )}
                            {field.customElement}
                          </div>
                        ) : (
                          <div className={`col-12 col-lg-${field.col_size}`}>
                            <div className="mb-3" />
                          </div>
                        )}
                      </React.Fragment>
  );
                  })}

                    {additional_field}
                  </div>

                  {/* BUTTONS */}
                  <div className="mt-4 d-flex justify-content-end align-items-center gap-2">
                    {btn_name1 && (
                      <Link
                        to={btn_name1_route}
                        className="btn btn-outline-secondary "
                      >
                        {btn_name1}
                      </Link>
                    )}

                    <button
                      type="submit"
                      className="btn btn-primary "
                    >
                      {btn_name}
                    </button>

                    {btn_name2 && (
                      <button
                        type="submit"
                        className="btn btn-info  text-white"
                      >
                        {btn_name2}
                      </button>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  };

  export default DynamicForm;
